import { ToastSwal } from '../../general/toastSwals/toastSwal';
import { asyncSharepointGetAuthUrl } from '../../../../services/sharepoint-graph.service';
import MicrosoftIcon from '@mui/icons-material/Microsoft';

interface ConnectButtonProps {
    setIsSharepointAuth: React.Dispatch<React.SetStateAction<boolean>>;
    setSharepointModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ConnectButton = ({
    setIsSharepointAuth,
    setSharepointModalOpen,
}: ConnectButtonProps) => {
    const connectToSharepoint = async () => {
        const redirectUrl = `${window.location.origin}/sharepoint-auth`;
        const { authenticated, authUrl } = await asyncSharepointGetAuthUrl(
            redirectUrl
        );

        if (authenticated) {
            setIsSharepointAuth(true);
            ToastSwal.fire({
                text: 'SharePoint conectado exitosamente',
                icon: 'success',
                timer: 3000,
                position: 'center-end',
            });
            setSharepointModalOpen(true);
        } else {
            window.open(authUrl, 'sharepointLogin', 'width=600,height=600');
        }
    };

    return (
        <button
            onClick={connectToSharepoint}
            style={{
                all: 'unset',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
            }}
        >
            <MicrosoftIcon />
            Conectar con SharePoint
        </button>
    );
};
